import type { TFunction } from "i18next";

/** „Маса 5 е заета от Иван Петров" — без сумата; без името (каса, по-стар
 *  облак, „ничия" сметка) — „Маса 5 е заета". */
export const tableTakenText = (t: TFunction, name: string, takenBy: string | null) =>
  takenBy
    ? t("ordering.moveTableTakenBy", { name, waiter: takenBy })
    : t("ordering.moveTableTaken", { name });
